import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { RedFlag } from '../interfaces/red-flag';

@Injectable({
  providedIn: 'root',
})
export class RedFlagsAdapter {
  private http = inject(HttpClient);

  getUsableRedFlags(): Observable<RedFlag[]> {
    return this.http.get<RedFlag[]>(`${environment.apiBaseUrl}/company/red-flags`);
  }
}
